import Preview from './preview';
import Animate from './animate';
import Prize from './prize';

export default {
    Preview,
    Animate,
    Prize
}